define('views/content/get_payment',['require','backbone','marionette','typeahead','bloodhound','models/manual_payment','models/credit_card','text!templates/content/get_payment.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('typeahead');
    require('bloodhound');

    var ManualPaymentModel = require('models/manual_payment');
    var CreditCardModel = require('models/credit_card');

    var temp = require("text!templates/content/get_payment.html");
    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'get-payment-page',
        titleKey: 'get_payment',
        selectedCustomer: null,

        initialize: function () {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',

                paymentAmountField: '#payment_amount',
                paymentScheduleField: '#payment_schedule',
                paymentCountField: '#payment_count',

                customerField: '.customers-typeahead',

                cardHolderName: '#card_holder_name',
                cardNumber: '#card_number',
                cardExpiryYear: '#expiry_year',
                cardExpiryMonth: '#expiry_month',
                cardCvc: '#card_cvc',

                getPaymentButton: '#get-payment-button',
                tdsCheck: '#is_3ds',
            };
        },

        events: {
            'click @ui.getPaymentButton': 'getPaymentButtonClicked'
        },

        onRender: function () {
            var _this = this;

            this.ui.select2Input.select2();

            // Setup typeahed for customer field
            var customerssTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'customers/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.customerField.val()));
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.customerField.typeahead({
                minLength: 3
            }, {
                name: 'customers',
                source: customerssTypeahedEngine,
                display: 'company_name'
            });

            // Get selected customers's id
            this.ui.customerField.bind('typeahead:select', function (ev, suggestion) {
                _this.selectedCustomer = suggestion.id;
            });

            // Check tds status parameter
            var tdsStatus = App.utils.getUrlParameter('tds_status');
            if (tdsStatus) {
                if (tdsStatus === '1') {
                    setTimeout(function () {
                        App.context.redirect('/payments/' + App.utils.getUrlParameter('payment_id'));
                    }, 3000);

                    App.utils.showMessage('success', App.polyglot.t('payment_success'));
                } else if (tdsStatus === '0') {
                    App.utils.showMessage('error', App.polyglot.t('purchase_failure'));
                }
            }
        },

        getPaymentButtonClicked: function () {
            var _this = this;

            if (!this.selectedCustomer) {
                App.utils.showMessage('error', App.polyglot.t('no_customer_selected_typeahead'));
                return;
            }

            this.ui.getPaymentButton.addClass('loading');

            var creditCard = new CreditCardModel({
                'card_holder_name':  this.ui.cardHolderName.val(),
                'card_number':  this.ui.cardNumber.val(),
                'card_expiry':  this.ui.cardExpiryMonth.val() + '/' + this.ui.cardExpiryYear.val(),
                'card_cvc':  this.ui.cardCvc.val()
            });

            var manualPayment = new ManualPaymentModel({
                'customer': this.selectedCustomer,
                'payment_amount': this.ui.paymentAmountField.val(),
                'payment_schedule': this.ui.paymentScheduleField.val(),
                'payment_count': this.ui.paymentCountField.val(),
                'credit_card': creditCard.toJSON(),
                'is_3d': this.ui.tdsCheck.prop('checked')
            });

            manualPayment.save(null, {
                success: function (model, response, options) {
                    _this.ui.getPaymentButton.removeClass('loading');
                    if (response.is_3ds) {
                        if (response.tds_html) {
                            // Open 3DS view
                            $('body').append('<iframe id="tds_frame"></iframe>');
                            $('#tds_frame').html(atob(response.tds_html));
                        } else if (response.tds_redirect_url) {
                            // Redirect to 3ds url
                            window.location.replace(response.tds_redirect_url);
                        }
                    } else {
                        App.context.redirect('/payments/' + model.get('id'));
                        App.utils.showMessage('success', App.polyglot.t('payment_success'));
                    }
                },
                error: function (model, response, options) {
                    _this.ui.getPaymentButton.removeClass('loading');

                    // Show error messages
                    if (response.responseJSON.errors) {
                        for (var i=0; i<response.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', response.responseJSON.errors[i].message);
                        }
                    }
                }
            });
        }
    });
});
